import { Outlet, Link } from "react-router-dom";
import { Sidebar } from "./sidebar";
import usePlan from "@/hooks/use-plan";
import { Button } from "@/components/ui/button";

export function AppShell() {
    const { data, loading } = usePlan();

    return (
        <div className="flex h-screen overflow-hidden">
            <Sidebar />
            <main className="flex-1 overflow-y-auto">
                <div className="container mx-auto max-w-6xl py-8 px-6">
                    {/* Show upgrade reminder for free plan users */}
                    {!loading && data?.plan === "free" && (
                        <div className="mb-4 rounded-md border border-yellow-200 bg-yellow-50 p-4 text-sm text-yellow-800">
                            <div className="flex items-center justify-between gap-4">
                                <div>
                                    You're currently on the Free plan. Upgrade to unlock higher usage limits and premium features.
                                </div>
                                <div>
                                    <Button asChild variant="link">
                                        <Link to="/account">Upgrade</Link>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}

                    <Outlet />
                </div>
            </main>
        </div>
    );
}
